









































































import Vue from 'vue'
import Component from 'vue-class-component'
import RespondecoDialog from '../../../main/dialog.vue'
import RespondecoForm from '../../components/respondeco-form.vue'
import UnifyFormInput from '@/shared/components/unify/unify-form-input.vue'
import { Injector } from '@/config/dependency-injection'
import UnifyButton from '@/shared/components/unify/unify-button.vue'
import { DialogComponent } from '@/shared/interfaces/dialog-component'
import UnifyList from '@/shared/components/unify/unify-list.vue'
import UnifyListItem from '@/shared/components/unify/unify-list-item.vue'
import UnifyListItemLabel from '@/shared/components/unify/unify-list-item-label.vue'
import UnifyListItemContent from '@/shared/components/unify/unify-list-item-content.vue'
import RespondecoDialogButtons from '@/main/dialog-buttons.vue'
import RespondecoDialogButton from '@/main/dialog-button.vue'
import UnifyFormToggle from '@/shared/components/unify/unify-form-toggle.vue'
import { DevelopmentService } from '@/shared/development/development-service'
import { DevelopmentSettings } from '@/shared/development/models/development-settings'
import {
  DevelopmentSettingsForm,
  developmentSettingsFormMapping,
} from '@/shared/development/models/development-settings-form'
import { DialogService } from '@/shared/dialog/dialog-service'
import { TypedForm } from '@/shared/forms/typed-form'
import UnifyTextarea from '@/shared/components/unify/unify-textarea.vue'

@Component({
  components: {
    UnifyTextarea,
    UnifyFormToggle,
    RespondecoDialogButton,
    RespondecoDialogButtons,
    UnifyListItemContent,
    UnifyListItemLabel,
    UnifyListItem,
    UnifyList,
    UnifyButton,
    UnifyFormInput,
    RespondecoForm,
    RespondecoDialog,
  },
  data() {
    return {
      form: undefined,
    }
  },
})
export default class DevelopmentSettingsModal extends Vue implements DialogComponent {
  public static dialogName = 'development-settings'

  public form!: TypedForm<DevelopmentSettings, DevelopmentSettingsForm>

  private developmentService = Injector.get(DevelopmentService)
  private dialogService = Injector.get(DialogService)

  public data() {
    return {
      form: new TypedForm(developmentSettingsFormMapping(), this),
    }
  }

  public validations() {
    return this.form.validations()
  }

  public beforeOpen(): void {
    this.form.reset(this.developmentService.getSettings())
  }

  public submit(): void {
    this.updateSettings(this.form.serialize())
  }

  private updateSettings(settings: DevelopmentSettings): void {
    this.developmentService.updateSettings(settings)

    this.dialogService.hide(DevelopmentSettingsModal)
  }
}
